/*
 * @Author: your name
 * @Date: 2022-11-11 15:17:36
 * @LastEditTime: 2022-12-20 11:07:35
 * @LastEditors: zhang lin
 * @Description: In User Settings Edit
 * @FilePath: /ops-manager-frontend/src/services/nanotube.ts
 */
import request from 'root/utils/request';

const basePath = '/api/ops-manager/v1/runtime_env/bind';

// 设置与更新纳管运行环境参数
export const updateNanotubeDataApi = async (params: any) => {
  return request.post(`/api/ops-manager/v1/supos/runtime_env/create_update`, params);
};

// 获取纳管
export const getNanotubeDataApi = async (params: { id: string }) => {
  return request.get(`/api/ops-manager/v1/supos/runtime_env/query`, { params: { ...params } });
};

// 单机纳管
export const singleBindApi = async (params: any) => {
  return request.get(`${basePath}/single`, { params: { ...params } });
};

// 集群纳管下载模板  暂时未用到
export const colonyBindDownloadApi = async () => {
  return request.get(`${basePath}/excel/download`, {
    responseType: 'blob',
  });
};

// excel上传失败后下载失败文件
export const exportErrorExcelApi = async (path: string) => {
  return request.get(`${basePath}/error/excel/download?path=${path}`, {
    responseType: 'blob',
  });
};

// 点击纳管
export const exportBindApi = async () => {
  return request.get(`${basePath}`);
};

// 查询纳管进度
export const getBindIngApi = async () => {
  return request.get(`${basePath}/excel/query`);
};

// 清空纳管
export const clearNanotube = async () => {
  return request.delete(`${basePath}/excel/clear`);
};

// 查询是否是纳管中
export const checkNanotubeApi = async () => {
  return request.get(`${basePath}/excel/status/query`);
};
